import { WithTranslation } from 'next-i18next';
import React from 'react';
import { withTranslation } from 'next-i18next';
import TicketMenu from '../../../dropdowns/TicketMenu';
import TimeMenu from '../../../dropdowns/TimeMenu';
import UserMenuForStudent from '../../../dropdowns/UserMenuForStudent';
import SubscribeButton from '../SubscribeButton';
import { Badge } from '@lb-classroom/ui';
import { MessageSquare } from 'lucide-react';
import Link from 'next/link';

const DefaultAvatar = '/static/images/default_avatar_orange.png';

interface Props extends WithTranslation {
  t: any;
  user: any;
  numUnseenMessages: number;
  currentLocale: string;
  authActions: any;
  userActions: any;
}

const StudentHeaderDesktopRightPart: React.FC<Props> = ({
  user,
  numUnseenMessages,
  currentLocale,
  authActions,
}: Props) => {
  const name = user.first_name;
  let avatarUrl = DefaultAvatar;
  if (user.thumb_avatar_url) {
    avatarUrl = user.thumb_avatar_url
      .replace('lingualbox-dev', 'lingualbox')
      .replace('lingualbox-staging-sg', 'lingualbox');
  }
  const studentProfile = user.student_profile;
  const subTicket = studentProfile.sub_ticket;
  const ticket = studentProfile.ticket;
  const timezone = user.js_time_zone;
  const ticketMenuProps = { subTicket, ticket };
  const { payment_info } = user;
  const planName = payment_info.name;
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8 md:items-center">
      <SubscribeButton planName={planName} />
      <TimeMenu timezone={timezone} currentLocale={currentLocale} />
      <TicketMenu {...ticketMenuProps} />
      <Link href="/messages" className="text-default link-reset relative">
        <MessageSquare className="h-7 w-7 text-secondary" />
        {numUnseenMessages > 0 && (
          <Badge
            variant="destructive"
            className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs"
          >
            {numUnseenMessages > 99 ? '99+' : numUnseenMessages}
          </Badge>
        )}
      </Link>
      <UserMenuForStudent
        name={name}
        avatarUrl={avatarUrl}
        handleLogout={authActions.logout}
      />
    </div>
  );
};

const wrapped = withTranslation('common')(StudentHeaderDesktopRightPart);

export default wrapped;
